import { createSelector } from 'reselect';

import {
  FETCH_RIGHTS_DAT_SUCCESS, FETCH_RIGHTS_JSON_SUCCESS,
} from '../../actions/rights';

import { extractRights, invertObject } from '../../utils/common';

import getUserPossibleTransitions from '../../utils/userPossibleTransitions';

const initialState = {
  rightsDat: [],
  rightsJson: {
    users: {},
    projects: {},
    rights: {}
  }
};

export default function rightsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_RIGHTS_DAT_SUCCESS:
      return {
        ...state,
        rightsDat: extractRights(action.payload.data),
    };
    case FETCH_RIGHTS_JSON_SUCCESS:
      return {
        ...state,
        rightsJson: action.payload.data,
      };
    default:
      return state;
  }
}

const getRightsJson = state => state.rights.rightsJson;
const getRightsDat = state => state.rights.rightsDat;

export const userPossibleTransitionsSelector = createSelector(
  [getRightsDat, getRightsJson],
  (rightsDat, rightsJson) => getUserPossibleTransitions(rightsDat, rightsJson)
);

export const invertedRightsJsonSelector = createSelector(
  [getRightsJson],
    (rightsJson) => {
      const toBeInverted = ['rights'];
      const invertedRightsJson = {};
      toBeInverted.forEach(objPart => {
        invertedRightsJson[objPart] = invertObject(rightsJson[objPart]);
      });
      return invertedRightsJson;
    }
);
